import { createSelector } from 'reselect';
import PredesComplianceMissingMandatoryElementsErrorMessagesColumns
  from '../../containers/PredesComplianceMissingMandatoryElementsErrorMessagesColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.getDataFunction();

export const getColumns =
  createSelector(getData, PredesComplianceMissingMandatoryElementsErrorMessagesColumns);
